import { f as r } from "./function-uncurry-this.js";
import { t } from "./to-integer-or-infinity.js";
import { t as o } from "./to-string.js";
import { r as i } from "./require-object-coercible.js";
var e = r("".charAt),
  n = r("".charCodeAt),
  s = r("".slice),
  c = function c(r) {
    return function (c, a) {
      var f,
        u,
        m = o(i(c)),
        h = t(a),
        j = m.length;
      return h < 0 || h >= j ? r ? "" : void 0 : (f = n(m, h)) < 55296 || f > 56319 || h + 1 === j || (u = n(m, h + 1)) < 56320 || u > 57343 ? r ? e(m, h) : f : r ? s(m, h, h + 2) : (f - 55296 << 10) + (u - 56320) + 65536;
    };
  },
  a = {
    codeAt: c(!1),
    charAt: c(!0)
  };
export { a as s };